import {getIsMsTeamsEnv} from '@lib/infrastructure';
import {AppDispatch} from '../createStore';
import {showTimedFeedback} from '../ui/userFeedbackView'; // Get rid of this
import {signOut} from './auth';

export const validationErrorName = 'ValidationError';
const authorizationErrorName = 'AuthorizationError';
const connectionErrorName = 'ConnectionError';
const genericErrorName = 'GenericError';
export const notFoundErrorName = 'NotFoundError';
export const appOutdatedError = 'AppOutdatedError';

export class ValidationError extends Error {
  title?: string;
  data?: any;

  constructor(message: string, title: string, data?: any) {
    super(message);
    this.name = validationErrorName;
    this.title = title ?? '';
    this.data = data;
  }
}

export class AuthorizationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = authorizationErrorName;
  }
}

export class ConnectionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = connectionErrorName;
  }
}

export class GenericError extends Error {
  constructor(message: string) {
    super(message);
    this.name = genericErrorName;
  }
}

export class EntityNotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = notFoundErrorName;
  }
}

export class AppOutdatedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = appOutdatedError;
  }
}

export const handleError = (error: any, dispatch: AppDispatch) => {
  const err = error as Error;
  if (err) {
    switch (err.name) {
      case appOutdatedError:
        console.log('App outdated error!', err.message);
        dispatch(showTimedFeedback({message: 'Please update your app', type: 'app-outdated'}));
        break;
      case validationErrorName:
      case connectionErrorName:
      case genericErrorName:
        dispatch(showTimedFeedback({message: error.message, type: 'error'}));
        break;
      case authorizationErrorName:
        dispatch(showTimedFeedback({message: error.message, type: 'error'}));
        dispatch(signOut({msteams: getIsMsTeamsEnv()}));
        break;
      default:
        break;
    }
  }
};
